<template>
  <div class="seniorclass-container">
    <div class="seniorclass-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/news">动态资讯</BreadcrumbItem>
        <BreadcrumbItem>{{detailInfo.title}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="seniorclass-detail">
          <div class="seniorclass-detail-img" v-if="detailInfo.picurl">
            <img :src="domainNameH5 + '/' + detailInfo.picurl" width="100%" alt="">
          </div>
          <div class="seniorclass-detail-cont">
            <div class="seniorclass-detail-item">{{detailInfo.title}}</div>
            <div class="seniorclass-detail-info">
              <span>发布人：{{detailInfo.author}}</span>
              <span>发布时间：{{detailInfo.posttime}}</span>
            </div>
            <div class="detail-cont" v-html="detailInfo.content"></div>
            <div class="detail-back" @click="backList">返回</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">动态资讯</div>
            <div class="enname">News</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData, getNewsBasicData, getNewsDetailData } from '../../api/getData.js'
export default {
  name: 'newsDetail',
  data () {
    return {
      headerInfo: {},
      page: 1,
      cid: '',
      id: '',
      pname: '',
      currentClassName: '',
      detailInfo: {}
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
      this.page = this.$route.query.page === undefined ? 1 : this.$route.query.page
      this.getNewsDetailInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.id = this.$route.query.id === undefined ? '' : this.$route.query.id
    this.page = this.$route.query.page === undefined ? 1 : this.$route.query.page
    this.getNewsBasicInfo()
    this.getNewsDetailInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid, id: this.id }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'news', activeSendMenu: '' }).then(() => {}).catch(() => {})
    },
    async getNewsBasicInfo () {
      let result = await getNewsBasicData()
      this.cid = result.cid
    },
    async getNewsDetailInfo () {
      let postData = {}
      postData.cid = this.cid
      postData.id = this.id
      postData.p = this.page
      let result = await getNewsDetailData(postData)
      this.detailInfo = result.info
      this.getHeaderInfo()
    },
    backList () {
      this.$router.push({ path: '/news', query: { page: this.page } })
    }
  }
}
</script>

<style scoped lang="less">
  .seniorclass-container_{
    padding-bottom: 60px;
  }
  .seniorclass-detail{
    width: 77.22%;
    padding: 0 66px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .seniorclass-detail-cont{
      padding: 0 0 80px;
      .seniorclass-detail-item{
        margin-top: 60px;
        font-size: 36px;
        line-height: 36px;
        color: #e76321;
        font-weight: bold;
      }
      .seniorclass-detail-info{
        margin-top: 20px;
        font-size: 18px;
        line-height: 33px;
        color: #4b7bbe;
        span{
          margin-right: 30px;
        }
      }
      .detail-cont{
        margin-top: 30px;
        padding-right: 22px;
        font-size: 24px;
        line-height: 42px;
        text-align: justify;
        color: #333333;
      }
      .detail-back{
        width: 200px;
        height: 60px;
        margin: 98px auto 20px;
        border-radius: 6px;
        background-color: #eb6420;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .seniorclass-detail{
      padding: 0 30px;
      .seniorclass-detail-cont{
        .seniorclass-detail-item{
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .seniorclass-detail{
      width: 100%;
      margin-bottom: 20px;
      padding: 0 15px;
      border-radius: 3px;
      .seniorclass-detail-cont{
        padding: 0 0 40px;
        .seniorclass-detail-item{
          margin-top: 30px;
          font-size: 18px;
          line-height: 18px;
        }
        .seniorclass-detail-info{
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
          span{
            margin-right: 15px;
          }
        }
        .detail-cont{
          margin-top: 15px;
          padding-right: 11px;
          font-size: 12px;
          line-height: 21px;
        }
        .detail-back{
          width: 100px;
          height: 30px;
          margin: 49px auto 10px;
          border-radius: 3px;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }
</style>
<style lang="less">
  .detail-cont{
    img,iframe,video{
      max-width: 100%;
    }
  }
</style>
